// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopFilledSvg from "@ant-design/icons-svg/es/asn/ShopFilled";
import AntdIcon from '../components/AntdIcon';

var ShopFilled = function ShopFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopFilledSvg
  }));
};

ShopFilled.displayName = 'ShopFilled';
export default React.forwardRef(ShopFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShopFilled.js
// module id = 1785
// module chunks = 0